import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { View, Text, StyleSheet } from 'react-native';
import { connect } from 'react-redux';
import {
  CheckBox, termsAndConditionsButtonPressedAction
} from '../../ui';

class TermsAndConditions extends Component {
  state = {};

  render() {
    const {
      isPrivacyPolicyVisible,
      isTermsOfServiceModalVisible,
      isTermsOfMembershipModalVisible,
      isTermsOfHomeMembershipModalVisible,
      isAllTermsAndConditionsVisible,
    } = this.state;
    const {
      t,
      preAgreementText,
      isMinor,
      termsAccepted,
      minorTermsAccepted,
      acceptTermsAndConditions,
      acceptMinorTermsAndConditions,
      canAccept,
      textStyle,
      checkBoxSize = 30,
      checkBoxInActiveOverrideStyle,
      termsAndConditionsButtonPressed,
    } = this.props;

    return (
      <View>
        <View style={styles.termsCheckboxContainer}>
          {canAccept &&
            <CheckBox
              size={checkBoxSize}
              onPress={acceptTermsAndConditions}
              isActive={termsAccepted}
              inActiveOverrideStyle={checkBoxInActiveOverrideStyle}
            />
          }
          <Text style={[styles.serviceTextContainer, textStyle]}>
            <Text>{preAgreementText} </Text>
            <Text
              onPress={termsAndConditionsButtonPressed}
              style={styles.textHighlight}>{t('TermsAndConditions')}
            </Text>
          </Text>
        </View>
        {isMinor &&
          <View style={styles.termsCheckboxContainer}>
            {canAccept &&
              <CheckBox
                size={checkBoxSize}
                onPress={acceptMinorTermsAndConditions}
                isActive={minorTermsAccepted}
              />
            }
            <Text style={[styles.serviceTextContainer, textStyle]}>
              <Text>{t('guardianTAndC')} </Text>
              <Text
                onPress={() => this.setIsTermsOfStudioMembershipModalVisible(true)}
                style={styles.textHighlight}>{t('studioTermsOfMembership')}
              </Text>
              <Text> + </Text>
              <Text
                onPress={() => this.setIsTermsOfHomeMembershipModalVisible(true)}
                style={styles.textHighlight}>{t('homeTermsOfMembership')}
              </Text>
              <Text> + </Text>
              <Text
                onPress={() => this.setIsTermsOfServiceModalVisible(true)}
                style={styles.textHighlight}>{t('termsOfPlatform')}
              </Text>
              <Text> + </Text>
              <Text
                onPress={() => this.setIsPrivacyPolicyVisible(true)}
                style={styles.textHighlight}>{t('privacyPolicy')}
              </Text>
            </Text>
          </View>
        }
      </View>
    );
  }
}

const styles = StyleSheet.create({
  serviceTextContainer: {
    ...Theme.textStyle.bodyCopyReg,
    flex: 1,
    textAlign: 'left',
    color: Theme.GREY_DARK,
    marginTop: -6,
  },
  textHighlight: {
    textDecorationLine: 'underline',
  },
  termsCheckboxContainer: {
    paddingVertical: defaultScale(10),
    flexDirection: 'row',
  },
});

const mapDispatchToProps = (dispatch) => ({
  termsAndConditionsButtonPressed: () => dispatch(termsAndConditionsButtonPressedAction()),
});

export default connect(null, mapDispatchToProps)(translate(['auth'], { wait: true })(TermsAndConditions));
